import { render } from "./ExtrasBadge.vue?vue&type=template&id=48e10e36"
import script from "./ExtrasBadge.vue?vue&type=script&lang=js"
export * from "./ExtrasBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/leaseitnow/ExtrasBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48e10e36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48e10e36', __exports__)) {
    api.reload('48e10e36', __exports__)
  }
  
  module.hot.accept("./ExtrasBadge.vue?vue&type=template&id=48e10e36", () => {
    api.rerender('48e10e36', render)
  })

}


export default __exports__